import { matchPath } from 'react-router';

import { PageTags, Params } from './types';

class PlanCheckoutTags extends PageTags {
  static get({ pathname, exact }: Params) {
    let currentPage = '';
    // eslint-disable-next-line no-restricted-syntax
    for (const [path] of Object.entries(this.container)) {
      const currentRoutePath = matchPath(pathname, { path, exact });
      if (currentRoutePath) {
        currentPage = path;
        break;
      }
    }

    if (this.container[currentPage]) {
      return this.container[currentPage];
    }
    return undefined;
  }

  static get container(): {[key: string]: string[]} {
    return {
      '/dashboard/plans/checkout': this.tags,
    };
  }

  static get tags() {
    return [
      'tag:checkout',
    ];
  }
}


export default PlanCheckoutTags;
